module.exports = __webpack_public_path__ + "f872b537c98fc9c66c55b2aa61d26f5a.svg";